module.exports = __webpack_public_path__ + "media/เป็นกล้วยอะไร.ee701b57.mp3";